<template>
  <div
    class="login"
    @keyup.enter="handleLogin"
  >
    <div class="login-header">
      <img
        class="login-header-logo"
        src="@/assets/login/logo@2x.png"
        alt=""
      />
      <span class="login-header-text line">|</span>
      <span class="login-header-text">智慧园区系统-运维端</span>
    </div>
    <div class="login-container">
      <div
        class="main"
        v-if="!forget"
      >
        <div class="main-select">
          <a
            href="javascript:;"
            :class="['main-select-text', isSmsLogin ? 'select' : null]"
            @click="handleLoginSwitch('sms')"
          >短信登录</a>
          <a
            href="javascript:;"
            :class="['main-select-text', !isSmsLogin ? 'select' : null]"
            @click="handleLoginSwitch('account')"
          >账号登录</a>
        </div>
        <a-form
          id="login-form"
          :form="form"
          class="login-form"
        >
          <div
            class="message"
            v-if="isSmsLogin"
            style="margin-top: 10%; margin-bottom: 6%"
          >
            <a-row>
              <a-col>
                <a-form-item>
                  <a-input
                    ref="inputRef"
                    v-decorator="[
                      'phone',
                      {
                        rules: [
                          {
                            type: 'string',
                            pattern: /^[1]([3-9])[0-9]{9}$/,
                            message: '请输入正确手机号',
                          },
                          {
                            required: true,
                            message: '请输入手机号',
                          },
                        ],
                      },
                    ]"
                    placeholder="请输入手机号"
                    size="large"
                  >
                    <a-icon
                      slot="prefix"
                      type="mobile"
                    />
                  </a-input>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col>
                <a-form-item>
                  <a-input
                    v-decorator="[
                      'code',
                      {
                        rules: [
                          {
                            required: true,
                            message: '请输入短信验证码',
                          },
                        ],
                      },
                    ]"
                    placeholder="请输入短信验证码"
                    ref="codeInput"
                    size="large"
                  >
                    <a-icon
                      slot="prefix"
                      type="mail"
                    />
                    <a-tooltip slot="suffix">
                      <a-button
                        type="link"
                        @click="sendVerificationCode"
                        :disabled="codeLoading"
                      >{{ codeText }}</a-button>
                    </a-tooltip>
                  </a-input>
                </a-form-item>
              </a-col>
            </a-row>
          </div>
          <div
            class="message"
            v-if="!isSmsLogin"
            style="margin-top: 10%"
          >
            <a-row>
              <a-col>
                <a-form-item>
                  <a-input
                    ref="inputRef"
                    v-decorator="[
                      'phone',
                      {
                        rules: [
                          {
                            type: 'string',
                            pattern: /^[1]([3-9])[0-9]{9}$/,
                            message: '请输入正确手机号',
                          },
                          {
                            required: true,
                            message: '请输入手机号',
                          },
                        ],
                      },
                    ]"
                    placeholder="请输入手机号"
                    size="large"
                  >
                    <a-icon
                      slot="prefix"
                      type="mobile"
                    />
                  </a-input>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col>
                <a-form-item>
                  <a-input
                    v-decorator="[
                      'password',
                      {
                        rules: [
                          {
                            required: true,
                            message: '请输入登录密码',
                          },
                        ],
                      },
                    ]"
                    type="password"
                    placeholder="请输入登录密码"
                    ref="codeInput"
                    size="large"
                  >
                    <a-icon
                      slot="prefix"
                      type="lock"
                    />
                  </a-input>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row
              type="flex"
              justify="space-between"
              style="margin-top: 0"
            >
              <a-col :span="12">
                <a-checkbox v-model="checked">记住登录状态</a-checkbox>
              </a-col>
              <a-col
                :span="6"
                style="text-align: right"
              >
                <a
                  href="javascript:;"
                  @click="handleForget"
                >忘记密码</a>
              </a-col>
            </a-row>
          </div>
        </a-form>
        <a-button
          style="width: 100%; margin-top: 9%"
          type="primary"
          size="large"
          @click="handleLogin"
          :loading="btnLoading"
        >登录</a-button>
      </div>
      <!-- 忘记密码表单 -->
      <forget-form
        v-else
        @cancel="handleForgetCancel"
      ></forget-form>
    </div>
    <div
      class="verify"
      v-show="showVerify"
    >
      <div class="verify-main">
        <div
          class="close"
          @click="hideVerify"
        >x</div>
        <p>请完成下列验证后继续</p>
        <slide-verify
          :l="42"
          :r="10"
          :w="310"
          :h="155"
          v-if="showVerify"
          slider-text="向右滑动"
          @success="onSuccess"
          @fail="onFail"
          @refresh="onRefresh"
          :imgs="puzzleImgList"
        ></slide-verify>
        <!-- :imgs="puzzleImgList" -->
      </div>
    </div>
  </div>
</template>

<script>
import loginService from "@/services/login.service";
import ForgetForm from "./ForgetForm";
import AES from "@/utils/AES";

export default {
  name: "Login",
  mounted() {
    this.$refs.inputRef.focus();
  },
  data() {
    return {
      puzzleImgList: [
        require("../../assets/login/0.jpg"),
        require("../../assets/login/1.jpg"),
        require("../../assets/login/2.jpg"),
      ],
      approved: false,
      showVerify: false,
      msg: "",
      form: this.$form.createForm(this, { name: "login_form" }),
      forget: false,
      confirmDirty: false,
      formItemLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 },
      },
      formLayout: "horizontal",
      codeText: "发送验证码",
      codeLoading: false,
      checked: false,
      isSmsLogin: true,
      btnLoading: false,
    };
  },
  methods: {
    hideVerify() {
      this.approved = false;
      this.showVerify = false;
    },
    onSuccess() {
      this.approved = true;
      this.$message.success("验证成功");
      setTimeout(() => {
        this.showVerify = false;
        this.sendVerificationCode();
        this.approved = false;
      }, 500);
    },
    onFail() {
      this.approved = false;
      this.msg = "";
    },
    onRefresh() {
      this.approved = false;
      this.msg = "";
    },
    // 忘记密码
    handleForget() {
      this.forget = true;
    },
    handleForgetCancel() {
      this.isSmsLogin = true;
      this.forget = false;
    },
    handleConfirmBlur(e) {
      const value = e.target.value;
      this.confirmDirty = this.confirmDirty || !!value;
    },
    compareToFirstPassword(rule, value, callback) {
      const form = this.passwordForm;
      if (value && value !== form.getFieldValue("password")) {
        // eslint-disable-next-line standard/no-callback-literal
        callback("两次密码输入不一致!");
      } else {
        callback();
      }
    },
    validateToNextPassword(rule, value, callback) {
      const form = this.form;
      if (value && this.confirmDirty) {
        form.validateFields(["confirm"], { force: true });
      }
      callback();
    },
    // 切换登录方式
    handleLoginSwitch(method) {
      if (method === "sms") {
        this.isSmsLogin = true;
        this.form.resetFields();
      } else {
        this.isSmsLogin = false;
        if (window.localStorage.getItem("checked")) {
          this.checked = true;
          this.$nextTick(() => {
            this.form.setFieldsValue({
              phone: window.localStorage.getItem("phone"),
              password: window.localStorage.getItem("password"),
            });
          });
        }
      }
      this.$nextTick(() => {
        this.$refs.inputRef.focus();
      });
    },
    // 发送验证码
    sendVerificationCode() {
      this.form.validateFields(["phone"], async (err, values) => {
        if (!err) {
          if (!this.approved) {
            this.showVerify = true;
          } else {
            this.codeLoading = true;
            const { status } = await loginService.getCode({
              phone: values.phone,
            });
            if (status === 0) {
              this.codeLoading = true;
              this.codeText = "60s后重试";
              let time = 60;
              let timer = setInterval(() => {
                time--;
                this.codeText = `${time}s后重试`;
                if (time === 0) {
                  this.codeText = "发送验证码";
                  this.codeLoading = false;
                  clearInterval(timer);
                }
              }, 1000);
            } else {
              this.codeLoading = false;
            }
          }
        }
      });
    },
    handleLogin(e) {
      e.preventDefault();
      this.form.validateFields(async (err, values) => {
        if (!err) {
          this.btnLoading = true;
          let form = {
            phone: values.phone,
            password: values.password || "",
            code: values.code || "",
          };
          // 加密
          // let encrypts = AES.encrypt(JSON.stringify(form))
          // let result = await loginService.login({ strLogin: encrypts })
          let result = await loginService.login(form);
          if (result.status === 0) {
            sessionStorage.setItem("username", values.phone);
            window.localStorage.setItem("token", result.result.token);
            if (!this.isSmsLogin) {
              if (this.checked) {
                window.localStorage.setItem("phone", values.phone);
                window.localStorage.setItem("password", values.password);
                window.localStorage.setItem("checked", 1);
              } else {
                window.localStorage.removeItem("checked");
                window.localStorage.removeItem("phone");
                window.localStorage.removeItem("password");
              }
            }
            this.$notification["success"]({
              message: "成功",
              description: "登录成功",
            });
            this.$router.push("/institution");
          }
          this.btnLoading = false;
        }
      });
    },
  },
  components: {
    ForgetForm,
  },
};
</script>

<style lang="less">
.login {
  .verify {
    position: fixed;
    z-index: 1001;
    top: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
    transition: all 0.5s ease-in-out;
    .verify-main {
      position: relative;
      box-sizing: content-box;
      background-color: #fff;
      width: 310px;
      margin: 25vh auto;
      text-align: center;
      padding: 20px 15px;
      border-radius: 5px;
      box-shadow: 3px 3px 5px #888888;
      .close {
        position: absolute;
        top: 0px;
        right: 10px;
        font-size: 20px;
        cursor: pointer;
        color: #555;
        &:hover {
          color: #333;
        }
      }
      .slide-verify {
        .slide-verify-slider-mask-item {
          height: 38px;
        }
      }
    }
  }
}
</style>

<style lang="less" scoped>
.login {
  width: 100%;
  height: 100vh;
  background: url("../../assets/login/bg_cover@2x.png") 0 0 no-repeat;
  background-size: 100% 100%;
  .login-header {
    padding: 4.17% 5% 0 5%;
    display: flex;
    align-items: center;
    .login-header-logo {
      width: 136px;
      height: 16px;
    }
    .line {
      margin: -3px 16px 0;
    }
    .login-header-text {
      font-size: 18px;
      font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
    }
  }
  .login-container {
    width: 52.19%;
    height: 58.8%;
    min-height: 450px;
    min-width: 700px;
    margin: auto;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 30px;
    background: url("../../assets/login/bg-login@2x.png") 0 0 no-repeat;
    background-size: 100% 101%;
    display: flex;
  }
  .main {
    position: absolute;
    width: 35%;
    height: 50%;
    right: 6%;
    top: 24%;
    .main-select {
      .main-select-text {
        font-size: 20px;
        font-family: MicrosoftYaHeiSemibold;
        color: rgba(204, 204, 204, 1);
        line-height: 32px;
        text-decoration: none;
        &:first-child {
          margin-right: 10%;
        }
      }
      .select {
        color: #5862cb;
      }
    }
  }
}
</style>
